import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Header, Home, TermsAndCondition, PrivacyPolicy } from "./";
import { useTranslation } from "react-i18next";
import Register from "./Register";
import Gallery from "./Gallery";

function Layout({ isHeaderColorActive }) {
  const { pathname } = useLocation();
  const {
    t,
    i18n: { changeLanguage },
  } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem("language");
    return storedLanguage ? storedLanguage : "en";
  });

  const handleChangeLanguage = () => {
    const newLanguage = currentLanguage === "en" ? "zh" : "en";
    setCurrentLanguage(newLanguage);
    localStorage.setItem("language", newLanguage);
    changeLanguage(newLanguage);
  };

  useEffect(() => {
    changeLanguage(currentLanguage);
  }, [currentLanguage, changeLanguage]);

  return (
    <>
      {pathname !== "/gallery/" && (
        <Header
          isHeaderColorActive={isHeaderColorActive}
          t={t}
          currentLanguage={currentLanguage}
          handleChangeLanguage={handleChangeLanguage}
        />
      )}
      <Routes>
        <Route
          path="/"
          element={<Home t={t} currentLanguage={currentLanguage} />}
        />
        <Route path="/gallery" element={<Gallery />} />
        {/* <Route path="/enquire-now" element={<Register />} /> */}
        <Route
          path="/terms-and-conditions"
          element={<TermsAndCondition t={t} />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy t={t} />} />
        <Route path="/start-your-project" element={<Register t={t} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default Layout;
